import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Table, Button, Flex, Popconfirm } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';
import { getRandomId } from '../../../../../../utilities/randomId';
import { getAsNumber } from '../../../../../../utilities/numberConvertion';
import { semesterLabel } from '../../../../../../const/semesterLabel';

const { table, actionSection } = courseStruct;


export const Course = ({ courses, updateSemester, apaPoint, semesterName, status }) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;



  const { course_type: courseType } = staticData;
  const defaultCourse = courseType?.length > 0 ? courseType[0] : {};
  const { value, credit } = defaultCourse;

  const [_courses, setCourses] = useState(courses?.length > 0 ? courses : []);
  const handleCourses = (courses) => setCourses(courses);

  const handleAdd = () => {
    const newPlaning = {
      key: getRandomId(),
      name: value,
      credit,
      score: 0,
      course_name: '',
      course_code: '',
      section: '',
      attachment: []
    };
    handleCourses([..._courses, newPlaning]);
  };

  const handleSave = (row) => {
    const currentCourses = [..._courses];
    const index = currentCourses.findIndex((item) => row.key === item.key);
    const item = currentCourses[index];

    row.credit = getAsNumber(row.credit);

    currentCourses.splice(index, 1, {
      ...item,
      ...row
    });
    handleCourses(currentCourses);
  };

  const handleDelete = (key) => {
    const newData = _courses.filter((item) => item.key !== key);
    handleCourses(newData);
  };

  const columns = [
    ...TableCol(handleSave, status),
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_, record) => {
        const { key } = record;

        return (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(key)}
            disabled={status === 1 || status === 2 || status === 3}
          >
            <a>Delete</a>
          </Popconfirm>
        );
      }
    }
  ];


  useEffect(() => {
    updateSemester(semesterName, _courses);
  }, [_courses, semesterName]);

  return courses ? (
    <>
      <Table
        {...table}
        columns={columns}
        dataSource={_courses}
        // loading={status === 3}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={columns.length - 2} align='right' >
              Calculated APA score for the {semesterLabel(semesterName)} semester:
            </Table.Summary.Cell>
            <Table.Summary.Cell colSpan={2}>{apaPoint}</Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      <br />



      <Flex {...actionSection}>
        <Button className="glow-btn" disabled={status === 1 || status === 2 || status === 3} onClick={handleAdd}>Add New Item</Button>
      </Flex>

      
    </>
  ) : (
    <></>
  );
};
